module.exports = __webpack_public_path__ + "static/media/arrow-right.a14e687f.svg";